define([
    'text!product-detail2024/component/sku-info-new.html',
    'product-detail2024/mixin/product',
    'WebCommon/component/image-360-new2024',
    'common/utils',
    'WebCommon/modal/cart-tip',
    'common/api',
    'product-detail2024/common/api',
    'lodash',
    'WebCommon/modal/modal',
    'WebCommon/component/num-input-group',
    'web/common/menu/menu',

    'css!product-detail2024/component/sku-info-new.css'
], function(
    tpl,
    ProductMixin,
    Image360,
    Utils,
    CartTip,
    Api,
    Newapi,
    _,
    Modal,
    NumInputGroup,
    Menu
){
    return {
        template: tpl,
        mixins: [ProductMixin],
        components: {
            Image360: Image360,
            CartTipModal: CartTip,
            NumInputGroup: NumInputGroup
        },
        computed: {
            detailImages: function(){
                return this.selectedSkuExtra.detailImages || [];
            },
            aboutDeliverPage: function(){
                var link = '/aboutdeliver';
                return this.isGrocery ? link+'?index=1' : link;
            },
            isSoldOut: function(){
                var storeNum = this.selectedSku.storeNum || 0;
                return storeNum <= 0;
            },
            isPC: function () {
                if($(window).width()<=750){
                    $('.fixed-menu').css({display: 'none'});
                    return false;
                }else {
                    return true;
                }
            },
            img360Height: function () {
                return $(window).height()-74;
            },
            img360Width: function () {
                return $(window).width()-500;
            }
        },
        data: function(){
            return {
                cartTipModal: {
                    isShow: false,
                    data: {}
                },
                buyNum:1,
                defaultBgColor: 'rgb(255,255,255)',
                proDetail: {},
                id: 0,
                picList: [],
                isPC: true
            };
        },
        watch: {
            selectedSku: function(newValue){
                if (!newValue) return;
                var query = _.assign({}, this.$route.query, {
                    id: newValue.id
                });
                this.$router.replace({
                    query: query
                });
                this.updateShareMenu();
            }
        },
        methods: {
            init: function(){
                var _this = this;
                if($(window).width()<=750){
                    _this.isPC = false;
                }else {
                    _this.isPC = true;
                }
                var url = window.location.href;
                var queryList = url.split('?')[1].split('&');
                for(var i=0;i<queryList.length;i++){
                    if (queryList[i].split('=')[0]=='id'){
                        _this.id = queryList[i].split('=')[1];
                        return
                    }
                }
            },
            getDetail: function(){
                var _this = this;
                var pr = {
                    id:  _this.id,
                    lang: ''
                };
                if(_this.$i18n.locale=='en'){
                    pr.lang = 'en';
                }
                Newapi.getProDetailApi.ajax(pr)
                    .done(function(data){
                        // console.log(data);
                        _this.proDetail = data.data;
                        if(data.data.scenPics){
                            var arr = data.data.scenPics.split(';');
                            for(var i=0;i<arr.length;i++){
                                if(arr[i]){
                                    _this.picList.push(arr[i])
                                }
                            }
                        }
                    });
            },
            getArea: function(len,index) {
                var _this = this;
                if(_this.selectedSku.categoryL2Bom=='C01-12-02'){
                    if(len==2&&_this.selectedSku.cusSpec[1].specValue){
                        var value = parseFloat(_this.selectedSku.cusSpec[1].specValue);
                        _this.selectedSku.cusSpec[0].specValue = (value * value).toFixed(4);
                    }else if(len==3&&_this.selectedSku.cusSpec[1].specValue&&_this.selectedSku.cusSpec[2].specValue){
                        var value1 = parseFloat(_this.selectedSku.cusSpec[1].specValue);
                        var value2 = parseFloat(_this.selectedSku.cusSpec[2].specValue);
                        _this.selectedSku.cusSpec[0].specValue = (value1 * value2).toFixed(4);
                    }
                }
            },

            onAddCart:function ()
            {
                var _this = this;
                if(_this.selectedSku.cusSpec.length==2){
                    if(_this.selectedSku.cusSpec[0].specValue&&_this.selectedSku.cusSpec[1].specValue){
                        _this.addCart();
                    }else {
                        alert('请完善购买信息')
                    }
                }else if(_this.selectedSku.cusSpec.length==3){
                    if(_this.selectedSku.cusSpec[0].specValue&&_this.selectedSku.cusSpec[1].specValue&&_this.selectedSku.cusSpec[2].specValue){
                        _this.addCart();
                    }else {
                        alert('请完善购买信息')
                    }
                }else {
                    _this.addCart();
                }
            },
            addCart: function() {
                var obj = this;
                if(obj.selectedSku.categoryL2Bom=='C01-12-02'){
                    obj.buyNum = obj.selectedSku.cusSpec[0].specValue;
                }
                Api.addCartApi.ajax(
                    {
                        bom: obj.selectedSku.bom,
                        buyNumber: obj.buyNum,
                        cusSpec_json: JSON.stringify(obj.selectedSku.cusSpec)
                    }
                ).done(function(data)
                {
                    obj.cartTipModal = {
                        isShow: true,
                        data: {
                            info: data,
                            onConfirm: function(){
                            }
                        }
                    };
                });
            },
            toHowBuy: function () {
                window.location.href = "/buyChannel";
            },

            login: function(from){
                Modal.showMemberLoginModal(from);
            },
            goNeedAuthPage: function(link){
                if (FNJISite.user.login=="1"){
                    window.location.href = link;
                } else {
                    this.login(link);
                }
            },

            onAddCartAndBuy:function ()
            {
                var _this = this;
                if(_this.selectedSku.cusSpec.length==2){
                    if(_this.selectedSku.cusSpec[0].specValue&&_this.selectedSku.cusSpec[1].specValue){
                        _this.addCartAndBuy();
                    }else {
                        alert('请完善购买信息')
                    }
                }else if(_this.selectedSku.cusSpec.length==3){
                    if(_this.selectedSku.cusSpec[0].specValue&&_this.selectedSku.cusSpec[1].specValue&&_this.selectedSku.cusSpec[2].specValue){
                        _this.addCartAndBuy();
                    }else {
                        alert('请完善购买信息')
                    }
                }else {
                    _this.addCartAndBuy();
                }
            },
            addCartAndBuy: function () {
                var obj = this;
                if(obj.selectedSku.categoryL2Bom=='C01-12-02'){
                    obj.buyNum = obj.selectedSku.cusSpec[0].specValue;
                }
                Api.addCartApi.ajax(
                    {
                        bom: obj.selectedSku.bom,
                        buyNumber: obj.buyNum,
                        cusSpec_json: JSON.stringify(obj.selectedSku.cusSpec)
                    }
                ).done(function(data)
                {
                    obj.goNeedAuthPage("/cart");
                    // window.location.href = "/v2/cart";

                });
            },

            genFurnitureDetailLink: Utils.genFurnitureDetailLink,
            getColorStyle: function(val){
                if (!this.isSpecActive('color', val)) return null;
                return {
                    backgroundColor: this.selectedSkuExtra.skuColor || this.selectedSkuExtra.bgColor
                };
            },
            isColorSpec: function(spec){
                return spec.bom === 'color';
            },
            updateShareMenu: function(){
                // console.log(this.selectedSku);
                var shareData = {
                    title: '梵几·生野安室 '+this.selectedSku.name,
                    url: location.href,
                    pic: Utils.genCdnImageUrl(this.selectedSku.mainPic)
                };
                Menu.setShareBtnData(shareData);
            }
        },
        mounted: function(){
            this.init();
            this.getDetail();
            var obj = this;
            $('.fixed-menu').css({display: 'none'});
            $(window).resize( function  () {           //当浏览器大小变化时
                if(($(window).width()<=750&&obj.isPC)||($(window).width()>750&&!obj.isPC)){
                    window.location.reload();
                }
            });
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./product-detail2024/component/sku-info-new.js
// module id = 225
// module chunks = 0